// extracted by mini-css-extract-plugin
export var sliderRange = "_cw-2";
export var sliderRoot = "_cw-0";
export var sliderThumb = "_cw-3";
export var sliderTrack = "_cw-1";